import axios from "axios";

export const baseurl = "/";

//http://localhost:7029/
export const FitnessCategory = () => {
  return axios.get(`${baseurl}api/videos`);
};


export const FitnessVideos = (id) => {
  return axios.get(`${baseurl}api/videos?category_id=${id}`);
};
